import React, { FC, ReactNode } from 'react';
import './DeleteButton.css';
import { FaTrash } from '@/Shared/Lib/UI/Icons';
import ActionButton from '../ActionButton/ActionButton';

interface DeleteButtonProps {
	onClick: () => void;
	label?: string;
	icon ? : ReactNode;
	showLabel? : boolean;
	classNames? : string;
	tooltip? : string;
	disabled? : boolean
}

const DeleteButton: FC<DeleteButtonProps> = ({ 
	onClick, label = "Supprimer", 
	icon = <FaTrash/>, 
	showLabel = false,
	classNames = "",
	tooltip = "Supprimer cet élément",
	disabled
}) => (
	<ActionButton
	    classNames = {`DeleteButton ${classNames}`}
		icon={icon}
		label={label}
		onClick={onClick}
		showLabel={showLabel}
		tooltip={tooltip}
		disabled={disabled}
	/>
);
export default DeleteButton;